import moment from "moment";
interface PayFrequency {
    value: string;
    label: string;
}

const pay_frequency: PayFrequency[] = [
    { value: "Weekly", label: "Weekly" },
    { value: "BiWeekly", label: "Bi-Weekly" },
    { value: "Monthly", label: "Monthly" },
    { value: "BiMonthly", label: "Bi-Monthly" },
    { value: "Yearly", label: "Yearly" },
    { value: "OneTime", label: "One-Time" },
];

export interface CalculatePayFrequencyInput {
    startDate: string;
    endDate: string;
}

export const calculatePayFrequency = ({ startDate, endDate }: CalculatePayFrequencyInput): PayFrequency => {
    if (!startDate || !endDate) {
        return { label: "Select", value: "" };
    }

    const startDate_ = moment(startDate);
    const endDate_ = moment(endDate);

    if (startDate_.isAfter(endDate_)) {
        return { label: "Select", value: "" };
    }

    const days = endDate_.diff(startDate_, "days") + 1;
    const monthDays = startDate_.daysInMonth();
    const isLeapYear = startDate_.isLeapYear();

    if ((monthDays === 28 && days === 13) || (isLeapYear && monthDays === 29 && days === 14)) {
        if (startDate_.date() == 16)
            return pay_frequency[3];
    }

    if (days == 1) return pay_frequency[5];
    if (days == 7) return pay_frequency[0];
    if (days == 14) return pay_frequency[1];
    if (startDate_.month() == endDate_.month()) {
        if (days == 28 || days == 29 || days == 30 || days == 31) return pay_frequency[2]
        if (startDate_.daysInMonth() == 31) {
            if (startDate_.date() == 1 && days==15) return pay_frequency[3];
            if (days == 16) return pay_frequency[3];
        } 
        else if ((monthDays==28 || monthDays == 29) && startDate_.date() != 1){
            return {label:"Select",value:''}
        }
        else if (days == 15) return pay_frequency[3];
    }
    if (days > 300) return pay_frequency[4];

    return { label: "Select", value: "" };
};
